import React from 'react';
import PropTypes from 'prop-types';
import Equalizer from 'react-equalizer';
import classnames from 'classnames';

/**
 * CurrencyTable (e.g. spot, settlement, forward)
 */
const CurrencyTable = (props) => {
    
    return (
        <div className="currency-table">
            <Equalizer
                nodes={(component, node) => {
                    return node.getElementsByTagName('th') || [];
                }}
                byRow={false}
            >
                {props.children}
            </Equalizer>
        </div>
    );
};

/**
 * CurrencyTableHeader using a equalizer to get the exact same height for each `th`
 * this is needed because in the first column the table cells are positioned absolute.
 * If in the other cells a text-wrap happens, then the first cell will not be equally sized.
 */
const CurrencyTableColumnsGroup = (props) => {
    const classNames = classnames('currency-table__columns-group', {
        'currency-table__columns-group--isFixed': props.isFixed,
        'currency-table__columns-group--isScrollable': !props.isFixed
    });

    return (
        <div className={classNames}>
            <table>
                <thead>
                {props.headerRow}
                </thead>
                <tbody>
                {props.contentRows}
                </tbody>
            </table>
        </div>
    );
};

CurrencyTableColumnsGroup.propTypes = {
    isFixed: PropTypes.bool,
    headerRow: PropTypes.node,
    contentRows: PropTypes.node
};


/**
 * Helper function to calculate equally sized fractions based on the numer of columns that
 * should be scrollable.
 */
const scrollableCellStyle = (numberOfScrollableCells) => {
    return {
        width: 100 / numberOfScrollableCells + '%'
    }
};

export default CurrencyTable;
export {CurrencyTableColumnsGroup, scrollableCellStyle};
